export const STRIPE_PRE_PAY = 'cdb/payment/stripe/prepay' // 原先的预授权租借
export const STRIPE_RECHARGE = 'cdb/payment/stripe/recharge' // 原先的订单付款
export const STRIPE_PREPAY_SPTOKEN = 'cdb/payment/stripe/multicurrency/preAuth/stripToken' // 目前使用的预授权租借
export const STRIPE_PAYORDER_SPTOKEN = 'cdb/payment/stripe/multicurrency/payOrder/stripToken' // 目前使用的订单付款
export const STRIPE_PAYORDER = 'cdb/payment/stripe/multicurrency/payOrder' // 信用卡订单付款
export const STRIPE_RECHARGE_WALLET = 'cdb/payment/stripe/multicurrency/rechargeWallet' // 创建钱包充值订单

export const STRIPE_PREAUTH_OF_CONFIRM = 'cdb/payment/stripe/multicurrency/preauthOfIntent/payment' // 信用卡预授权租借
export const STRIPE_CLIENTSECRET = 'cdb/payment/stripe/multicurrency/clientSecret' // 获取客户秘钥
export const STRIPE_PREAUTH_AUTO_CONFIRM1 = 'cdb/payment/stripe/authConfirm'
export const STRIPE_PREAUTH_AUTO_CONFIRM = 'cdb/payment/stripe/multicurrency/confirm' // 信用卡确认订单
export const STRIPE_PAYCONFIRM = 'cdb/payment/stripe/multicurrency/payConfirm/payment' // 确认订单-旧

export const STRIPE_SAVE_CARD = 'cdb/payment/stripe/multicurrency/saveCardOfIntent' // stripe保存卡
export const STRIPE_SAVE_CARD_CONFIRM = 'cdb/payment/stripe/multicurrency/saveCardConfirm' // stripe保存卡确认
export const SAVED_CARD_RENT = 'cdb/payment/stripe/multicurrency/preauthByCard/payment' // 已保存卡租借
export const SAVED_CARD_TO_RENT = 'cdb/cabinet/savedCardToRent'
export const PAYMODE = 'cdb/cabinet/check/payment' // 获取支付方式列表
export const MPESA_DEPOSIT_RENT = 'cdb/cabinet/useDepositToRent' // 押金租借

export const PAYPAL_PREAUTH = 'cdb/payment/paypal/multicurrency/preauth/' // 创建预授权订单{qrcode}
export const SAVE_CARD_SETUP_TOKEN = 'cdb/payment/paypal/multicurrency/setupToken' // paypal保存卡
export const SAVE_CARD_SAVE_TOKEN = 'cdb/payment/paypal/multicurrency/saveToken' // paypal保存卡确认
export const PAYPAL_PAYORDER = 'cdb/payment/paypal/multicurrency/payOrder'
export const PAYPAL_PAYORDER_COMFIRM = 'cdb/payment/paypal/multicurrency/payment/confirm'

export const PAYPAL_PRE_PAY = 'cdb/payment/paypal/prepay'
export const PAYPAL_RECHARGE = 'cdb/payment/paypal/recharge'
export const PAYPAL_EXC_PAY = 'cdb/payment/paypal/excpay'
// MopepePayment
export const MOPEPE_RECHARGE = 'cdb/payment/mopepe/multiCurrency/recharge' // 钱包充值或租借
export const MOPEPE_PAY = 'cdb/payment/mopepe/multiCurrency/payOrder' // 订单付款
export const MOPEPE_CONFIRM = 'cdb/payment/mopepe/multiCurrency/payment/confirm' // 确认订单

// 肯尼亚支付
export const MPESA_RECHARGE = 'cdb/payment/m-pesa/multiCurrency/recharge' // 钱包充值
export const MPESA_PAYORDER = 'cdb/payment/m-pesa/multiCurrency/payOrder' // 订单付款
export const MPESA_VIPORDER = 'cdb/payment/m-pesa/multiCurrency/vipOrder' // 购买vip
export const MPESA_PAYCONFIRM = 'cdb/payment/m-pesa/multiCurrency/payment/confirm' // 确认订单
export const SAVE_CARD = 'cdb/payment/quickpay/multiCurrency/saveCard' // 保存卡

// 卡塔尔支付通道
export const MYFATOORAH_PAYORDER = 'cdb/payment/myfatoorah/payOrder' // 订单付款
export const MYFATOORAH_RECHARGE = 'cdb/payment/myfatoorah/recharge' // 钱包充值
export const MYFATOORAH_PREAUTH_AUTHORDER = 'cdb/payment/myfatoorah/preAuthOrder' // 信用卡创建预授权订单
export const MYFATOORAH_PREAUTH_OF_CONFIRM = 'cdb/payment/myfatoorah/payment/confirm' // 订单支付确认

// midtrans 支付
export const MIDTRANS_RECHARGE = "cdb/payment/midtrans/multicurrency/recharge" // 充值
export const MIDTRANS_PAYORDER = "cdb/payment/midtrans/multicurrency/payOrder" // 订单付款

// v2 统一入口（调用需使用 $postV2/$getV2，JSON body；stripe/paystack 通用）
export const STRIPE_V2_RECHARGE = "payment/v2/recharge" // 统一下单（预授权/订单付款/充值）
export const STRIPE_V2_SYNC = "payment/v2/sync" // 统一查证（确认订单）
export const STRIPE_V2_SAVE_CARD = "payment/v2/saveCardOfIntent" // 统一存卡（intent + confirm）

// PayStack DVA（虚拟账户 + mandate 代扣，v2 业务路径，调用需使用 $postV2/$getV2）
export const PAYSTACK_DVA_ASSIGN = "payment/v2/paystack/dva/assign"
export const PAYSTACK_DVA_QUERY = "payment/v2/paystack/dva"
export const PAYSTACK_DVA_DEACTIVATE = "payment/v2/paystack/dva/deactivate"
export const PAYSTACK_DVA_MANDATE_INIT = "payment/v2/paystack/dva/mandate"
export const PAYSTACK_DVA_MANDATE_QUERY = "payment/v2/paystack/dva/mandate"
export const PAYSTACK_DVA_MANDATE_DEACTIVATE = "payment/v2/paystack/dva/mandate/deactivate"
export const PAYSTACK_DVA_PAY_ORDER = "payment/v2/paystack/dva/pay/order"
export const PAYSTACK_DVA_PAY_ORDER_STATUS = "payment/v2/paystack/dva/pay/order/status"

// PayStack 保存卡（v2 业务路径，调用需使用 $postV2/$getV2）
export const PAYSTACK_CARD_SAVE = "payment/v2/paystack/card/save"
export const PAYSTACK_CARD_LIST = "payment/v2/paystack/card/list"
export const PAYSTACK_CARD_DELETE = "payment/v2/paystack/card/delete"
export const PAYSTACK_CARD_RENT = "payment/v2/paystack/card/rent"

// 海外支付统一入口（paymentez mixin 引用）
export const MULTICURRENCY_RECHARGE = "cdb/payment/multicurrency/recharge" // 钱包充值/订单付款/购买VIP
export const MULTICURRENCY_PAYCONFIRM = "cdb/payment/multicurrency/payment/confirm" // 确认订单
export const MULTICURRENCY_SAVECARDOFINTENT = "cdb/payment/multicurrency/saveCardOfIntent" // 保存卡意图
